/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  CUSTOM_DEFAULT_FILE_ICON,
  CUSTOM_FILE_AUDIO_ICON,
  CUSTOM_FILE_CSS_ICON,
  CUSTOM_FILE_EXCEL_ICON,
  CUSTOM_FILE_IMAGE_ICON,
  CUSTOM_FILE_JS_ICON,
  CUSTOM_FILE_PDF_ICON,
  CUSTOM_FILE_POWERPOINT_ICON,
  CUSTOM_FILE_VIDEO_ICON,
  CUSTOM_FILE_WORD_ICON,
  CUSTOM_ICON_FILE_COLOUR,
} from '@squiz/sds';
import { FileExplorerFileIconProps } from './FileExplorerFileIcon.props';

export const FileExplorerFileIcon = ({ contentType }: FileExplorerFileIconProps): JSX.Element => {
  switch (true) {
    case contentType?.startsWith('image/'):
      return CUSTOM_FILE_IMAGE_ICON;
    case contentType === 'application/pdf':
      return CUSTOM_FILE_PDF_ICON;
    case contentType?.startsWith('audio/'):
      return CUSTOM_FILE_AUDIO_ICON;
    case contentType?.startsWith('video/'):
      return CUSTOM_FILE_VIDEO_ICON;
    case contentType === 'application/msword' ||
      contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return CUSTOM_FILE_WORD_ICON;
    case contentType === 'application/vnd.ms-excel' ||
      contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return CUSTOM_FILE_EXCEL_ICON;
    case contentType === 'application/vnd.ms-powerpoint' ||
      contentType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return CUSTOM_FILE_POWERPOINT_ICON;
    case contentType === 'text/html':
      return CUSTOM_ICON_FILE_COLOUR;
    case contentType === 'text/css':
      return CUSTOM_FILE_CSS_ICON;
    case contentType === 'application/javascript':
      return CUSTOM_FILE_JS_ICON;
    default:
      return CUSTOM_DEFAULT_FILE_ICON;
  }
};
